import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
// BI 확정 폰트(08-14). CDN이 아니라 패키지 self-host — 외부 주소를 소스에 두지 않는다.
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root 엘리먼트를 찾지 못했다')

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
})

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
